import { render, staticRenderFns } from "./import.vue?vue&type=template&id=3e0ac79e&"
import script from "./import.vue?vue&type=script&lang=js&"
export * from "./import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0ac79e')) {
      api.createRecord('3e0ac79e', component.options)
    } else {
      api.reload('3e0ac79e', component.options)
    }
    module.hot.accept("./import.vue?vue&type=template&id=3e0ac79e&", function () {
      api.rerender('3e0ac79e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/school/import.vue"
export default component.exports